import dayjsLib from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

export const timezones = {
  ASIA_MANILA: 'Asia/Manila'
}

dayjsLib.extend(isSameOrAfter)
dayjsLib.extend(utc)
dayjsLib.extend(timezone)
dayjsLib.tz.setDefault(timezones.ASIA_MANILA)

export const dayjs = (date) => dayjsLib(date).tz()

export const MMDDYYYY = 'MM/DD/YYYY'
export const YYYYMMDD = 'YYYY/MM/DD'
export const DATEPICKER = 'YYYY-MM-DD'
export const FULLDATE = 'MMMM DD, YYYY'
export const TIMESTAMP_FORMAT = 'MM/DD/YYYY HH:mm'
